import { useEffect } from "react";
import { MISC_INFO } from "../../reduxStore/actions/main";
import { pageNames } from "../../reduxStore/reducers/main";

export default function useRedirect(props) {
  const redirect = () => {
    // todo: die kacke muss in ein <Redirect /> gebaut werden
    if (
      props.serverDataLoaded &&
      props.location.pathname.length === 1 && // pathname zeichen müsste demnach -> "/" sein
      (props.introComplete === "true" || props.introComplete === true)
    ) {
      const firstElement = MISC_INFO.tabBarOrder?.[0];
      switch (firstElement) {
        case "events":
          // WICHTIG ZU WISSEN: wenn ein "/" ganz am anfang der url ist, dann wird diese ERSETZT
          // ist kein "/" am anfang der URL, wird diese auf die momentane GEPUSHT!
          // hier in App.jsx ist das okay, weil wir uns gerade im root befinden!
          props.history.push(`/${pageNames.events}/${window.location.search}`);
          break;
        case "news":
          props.history.push(`/${pageNames.news}/${window.location.search}`);
          break;
        default:
          props.history.push(
            `/${pageNames.map}/${pageNames.info}/${window.location.search}`
          );
      }
    }
  };

  useEffect(redirect, [
    props.location.pathname.length,
    props.introComplete,
    props.serverDataLoaded,
  ]);
}
